<template>
  <div
    class="vz-individual-order-header-multi-offer pdf-order-section-hide"
    :class="{ 'is-personal': isPersonal, 'hide-join': hideJoin }"
  >
    <img v-if="isPersonal && hideJoin" src="/images/pages/order/free.png" style="margin: -30px -25px -30px 0">
    <img v-else-if="isPersonal && !hideJoin" src="/images/pages/order/puzzles.png" style="margin: -10px -25px">
    <div v-if="isPersonal" v-html="content"/>
<!--    <div v-else class="multi-offer-public">-->
<!--      Заберём Ваш груз <div style="text-transform: uppercase">бесплатно</div>-->
<!--    </div>-->

    <slot name="button">
      <vz-button
        v-if="hideJoin === false"
        big
        :to="{ name: 'personal-multi-pickup' }"
      >
        Объединить
      </vz-button>

      <vz-button
        v-else-if="hideJoin && guid"
        :to="`/personal/order/create/?clone=${guid}`"
        big
      >
        Создать на основе
      </vz-button>
    </slot>
  </div>
</template>

<script setup lang="ts">
import VzButton from "~/components/ui-kit/vz-button.vue";
import {storeToRefs} from 'pinia';
import {useUserStore} from '~/stores/personal/user';

const props = defineProps({
  content: {
    type: String,
    default: ''
  },
  hideJoin: {
    type: Boolean,
    default: false
  }
})

const route = useRoute()
const {isAuth} = storeToRefs(useUserStore())

const guid = computed((): string => {
  return route.params?.guid as string || ''
})

const isPersonal = computed(() => {
  return isAuth.value && guid.value
})
</script>

<style lang="scss" scoped>
.vz-individual-order-header-multi-offer {
  margin-top: 20px;
  width: 100%;
  background: $section-gray;
  padding: 10px 30px;
  display: flex;
  //justify-content: center;
  align-items: center;
  border-radius: 6px;
  font-size: 16px;
  gap: 14px;
  line-height: 18px;

  :deep(.vz-button) {
    min-width: 209px;
    height: 36px;
    display: flex;
    justify-content: center;
    font-size: 14px;
    margin-left: auto;
    background-color: $white;
    color: $black;
  }

  &.is-personal {
    background: linear-gradient(271.41deg, #8F70AA 4.05%, #FEEDFF 67.12%);
    color: black;

    :deep(.vz-button) {
      &:hover {
        background-color: #9276ab;
        border-color: #9276ab;
      }
    }

    &:not(.hide-join) {
      font-weight: 600;
    }
  }

  &:not(.is-personal) {
    background-image: url("/images/pages/order/get-cargo.png");
    height: 81px;

    :deep(.vz-button) {
      background: linear-gradient(90deg, #94CCED 50%, #A6A4EB 78.2%);
      border: none;
    }


    @media screen and (max-width: $ord-md) {
      :deep(.vz-button) {
        min-width: 137px !important;
      }
    }

    @media screen and (max-width: $pub-md) {
      background-image: url("/images/pages/order/get-cargo_md.png");
      background-repeat: no-repeat;
      background-color: transparent;
      background-position: center;
      height: 246px;
      width: 100%;
      flex-direction: column;
      justify-content: flex-end;

      :deep(.vz-button) {
        margin-left: unset;
        min-width: 206px !important;
      }
    }
    @media screen and (max-width: $xs) {
      :deep(.vz-button) {
        margin-left: unset;
        min-width: 100% !important;
      }
    }
  }

  @media screen and (max-width: $ord-md) {
    :deep(.vz-button) {
      min-width: 182px;
    }
  }

  @media screen and (max-width: $pub-md) {
    :deep(.vz-button) {
      min-width: 145px;
    }
  }

  @media screen and (max-width: $ord-sm) {
    flex-direction: column;
    text-align: center;

    :deep(.vz-button) {
      min-width: 100%;
      margin-bottom: 10px;
    }

    &.is-personal {
      background: linear-gradient(1.41deg, #8F70AA 19.36%, #FEEDFF 90.01%);
    }
  }
}
</style>